/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ input: NonNullable<unknown>, output: NonNullable<unknown> }} Agent_Run_TokensInputs */



/**
* | output |
* | --- |
* | "{input} in / {output} out tokens" |
*
* @param {Agent_Run_TokensInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_tokens = /** @type {((inputs: Agent_Run_TokensInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_TokensInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.input} rein / ${i?.output} raus Tokens`)
	return /** @type {LocalizedString} */ (`${i?.input} in / ${i?.output} out tokens`)
});